import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import styles from "./index.module.less";
import ConfigSwitch from "./common/ConfigSwitch";
import { IconClose, IconWallPaperTitle } from "@/components/Icon";
import selectPic from "@/assets/images/select_pic.svg";
import FilePicker from "@/components/FilerPicker";
import { getDownloadLinkAPI } from "@/apis/getDownloadLinkAPI";
import UploadFile from "@/components/UploadFile";

const WallPaperSetting = ({ values, onChange, readOnly }) => {
  const { t } = useTranslation();

  return (
    <Box flex={1}>
      <Typography variant="h5" style={{ marginBottom: 32 }}>
        {t({ defaultMessage: "壁纸配置" })}
      </Typography>
      <ConfigSwitch
        title={t({ defaultMessage: "是否启用" })}
        name={`${wallPaperSettingName}.open`}
        onChange={onChange}
        marginBottom={3}
        value={values.open}
      />
      {values.open && (
        <Box display="flex" flexWrap="wrap">
          <WallPaper
            title={t({ defaultMessage: "主屏幕" })}
            subTitle={t({ defaultMessage: "横向模式" })}
            name={`${wallPaperSettingName}.main_screen_horizontal`}
            value={values.main_screen_horizontal}
            onChange={onChange}
            readOnly={readOnly}
          />
          <WallPaper
            title={t({ defaultMessage: "主屏幕" })}
            subTitle={t({ defaultMessage: "纵向模式" })}
            name={`${wallPaperSettingName}.main_screen_portrait`}
            value={values.main_screen_portrait}
            onChange={onChange}
            readOnly={readOnly}
          />
          <WallPaper
            title={t({ defaultMessage: "锁屏" })}
            subTitle={t({ defaultMessage: "横向模式" })}
            name={`${wallPaperSettingName}.lock_screen_horizontal`}
            value={values.lock_screen_horizontal}
            onChange={onChange}
            readOnly={readOnly}
          />
          <WallPaper
            title={t({ defaultMessage: "锁屏" })}
            subTitle={t({ defaultMessage: "纵向模式" })}
            name={`${wallPaperSettingName}.lock_screen_portrait`}
            value={values.lock_screen_portrait}
            onChange={onChange}
            readOnly={readOnly}
          />
        </Box>
      )}
    </Box>
  );
};

const WallPaper = ({ title, subTitle, name, onChange, value, readOnly }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");
  const [uploadOpen, setUploadOpen] = useState(false)

  const onConfirm = chosen => {
    onChange({
      target: {
        name,
        value: {
          id: chosen[0].id,
          file_path: chosen[0].s3_path || chosen[0].file_path,
          md5: chosen[0].md5
        }
      }
    });
  };

  const handleDelete = e => {
    e.stopPropagation();
    onChange({
      target: {
        name,
        value: {
          "id": "",
          "file_path": "",
          "md5": ""
        }
      }
    });
  };

  useEffect(() => {
    if (value.id) {
      getDownloadLinkAPI(value.id, true).then(setUrl);
    } else {
      setUrl("");
    }
  }, [value.id]);

  return (
    <>
      <div className={styles.wallPaperRoot}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: 24,
            alignItems: "center"
          }}
        >
          <IconWallPaperTitle size={16} style={{ marginRight: 12 }} />
          <div
            style={{
              color: "#00afc6",
              fontSize: 16,
              fontWeight: "bold",
              lineHeight: 1
            }}
          >
            {title}
          </div>
          <div
            style={{
              color: "#333",
              fontSize: 16,
              fontWeight: "bold",
              margin: "0 6px",
              lineHeight: 1
            }}
          >
            ·
          </div>
          <div
            style={{
              color: "#333",
              fontSize: 16,
              fontWeight: "bold",
              lineHeight: 1
            }}
          >
            {subTitle}
          </div>
          <Button
            variant="outlined"
            color="primary"
            style={{ minWidth: 118, marginTop: 24, marginBottom: 24, marginLeft: 16 }}
            onClick={() => setUploadOpen(true)}
            disabled={readOnly}
          >
            {t({ defaultMessage: "上传本地壁纸" })}
          </Button>
        </div>
        <div
          className={styles.wallPaperWrapper}
          onClick={() => {
            if (readOnly) return;
            setOpen(true);
          }}
        >
          {url ? (
            <>
              <img src={url} style={{ height: "100%" }} />
              <div className={styles.closeIcon} onClick={handleDelete}>
                <IconClose color="rgb(245,74,68)" />
              </div>
            </>
          ) : (
            <>
              <img src={selectPic} style={{ width: 80, marginBottom: 20 }} />
              <div
                style={{ color: "#00afc6", fontSize: 14, fontWeight: "bold" }}
              >
                {t({ defaultMessage: "从文件选择图片" })}
              </div>
            </>
          )}
        </div>
      </div>
      <UploadFile
        open={uploadOpen}
        onClose={() => setUploadOpen(false)}
        onSuccess={data => onConfirm([data])}
        type="image/*"
      />
      <FilePicker
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={onConfirm}
        title={t({defaultMessage: "选择图片"})}
        single
        filter={v => v.extension !== "svg"}
      />
    </>
  );
};

export const initValues = {
  open: false,
  // 四张壁纸分别对应 桌面横纵， 锁屏横纵
  main_screen_horizontal: { id: "", file_path: "", md5: "" },
  main_screen_portrait: { id: "", file_path: "", md5: "" },
  lock_screen_horizontal: { id: "", file_path: "", md5: "" },
  lock_screen_portrait: { id: "", file_path: "", md5: "" }
};
export const wallPaperSettingName = "wallpaperConfig";
export default WallPaperSetting;
